export const appVersion = (state) => state.app.version;
export const sidebar = (state) => state.app.sidebar;
export const size = (state) => state.app.size;
export const device = (state) => state.app.device;
export const answeredCalls = (state) => state.app.answeredCalls;
export const closedCalls = (state) => state.app.closedCalls;
// export const token = (state) => state.operator.token;
// export const avatar = (state) => state.operator.avatar;
// export const name = (state) => state.operator.name;
// export const introduction = (state) => state.operator.introduction;
// export const roles = (state) => state.operator.roles;
// /* export const roles = state => state.operators.roles; */
export const permission_routes = (state) => state.permission.routes;
export const errorLogs = (state) => state.errorLog.logs;
export const wgId = (state) => state.app.callCenter?.wgs[0]?.id;
export const centralId = (state) => state.app.callCenter?.wgs[0]?.centrals[0]?.id;
